<form [formGroup]="form" (ngSubmit)="save()">
    <h1 mat-dialog-title>{{ observationDialogEditRequest.textMenu }}</h1>

    <mat-form-field *ngIf="observationDialogEditRequest && observationDialogEditRequest.filterItems" class="full-width">
      <mat-select formControlName="filterItem" [placeholder]="observationDialogEditRequest.filterText" required>
          <mat-option *ngFor="let filter of observationDialogEditRequest.filterItems" [value]="filter">
              {{ filter.Name }}
          </mat-option>
      </mat-select>
      <mat-error *ngIf="f.filterItem.errors && f.filterItem.errors.required">
          Seleccione un motivo
      </mat-error>
  </mat-form-field>

    <mat-form-field class="full-width">
        <textarea formControlName="observation" matInput placeholder="Observaciones"></textarea>
        <mat-error *ngIf="f.observation.errors && f.observation.errors.required">
            Debe escribir una observación
        </mat-error>
    </mat-form-field>


    <div class="clearfix">
        <div class="pull-right">
            <button mat-button type="submit">Guardar</button>
            <button mat-button type="button" cdkFocusInitial (click)="onNoClick()">Salir</button>
        </div>
    </div>
</form>
